import React from "react";
import { Box, Typography, Container } from "@mui/material";
import GuestNavbar from "./GuestNavbar";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useGuestEmailVerification } from "./hooks/useGuestEmailVerification";
import { useGuestReferralStorage } from "./hooks/useGuestReferralStorage";
import GuestEmailVerificationForm from "./components/GuestEmailVerificationForm";
import GuestBondTypeGrid from "./components/GuestBondTypeGrid";
import GuestPageFooter from "./components/GuestPageFooter";

const GuestRequestSample = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  useGuestReferralStorage(searchParams);
  const {
    email,
    setEmail,
    checking,
    emailVerified,
    emailExists,
    errorMsg,
    onVerifyEmail,
  } = useGuestEmailVerification();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: "#f5f7fb", pb: 10 }}>
      <GuestNavbar />
      <Container maxWidth="lg" sx={{ flex: 1, py: { xs: 3, md: 5 } }}>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h4" sx={{ fontWeight: 800, color: "#0f172a", letterSpacing: -0.3 }}>
            Request a Bond as Guest
          </Typography>
          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            Start by verifying your email. If you already have an account, we’ll guide you to sign in.
          </Typography>
        </Box>

        {!emailVerified ? (
          <GuestEmailVerificationForm
            email={email}
            setEmail={setEmail}
            checking={checking}
            emailExists={emailExists}
            errorMsg={errorMsg}
            onVerifyEmail={onVerifyEmail}
            onNavigateLogin={() => navigate("/")}
          />
        ) : (
          <GuestBondTypeGrid onSelectPath={(path) => navigate(path)} />
        )}
      </Container>
      <GuestPageFooter />
    </Box>
  );
};

export default GuestRequestSample;
